import { render, staticRenderFns } from "./InstitutionViewInstitutionAddressCard.vue?vue&type=template&id=5b4e0ed5&"
import script from "./InstitutionViewInstitutionAddressCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionViewInstitutionAddressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports